// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] + "." + {"440":"a332a91d","581":"3aaf304d"}[chunkId] + ".chunk.js";
};